
  export default {
    name: 'Theme2MissionDesktopTypeThreeActivityCard',
    props: {
      title: {
        type: String,
        default: ''
      },
      rewardAmount: {
        type: Number,
        default: 0
      },
      disabled: {
        type: Boolean,
        default: false
      },
      img: {
        type: String,
        default: ''
      },
      activityStatus: {
        type: Number,
        default: 0
      },
      activityId: {
        type: String,
        default: ''
      },
      missionId: {
        type: String,
        default: ''
      },
      description: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        displaySuccessClaimDialog: false,
        displayActivityDetailDialog: false,
        claimLoading: false
      }
    },
    methods: {
      async onClaimActivity() {
        if (this.activityStatus === 1 || this.activityStatus === 3) {
          return
        }
        this.claimLoading = true
        const response = await this.$store.dispatch('activities/mission-reward/claimActivity', {
          activity_id: this.activityId,
          mission_id: this.missionId
        })
        if (response) {
          // To get notifications
          this.$store.dispatch('activities/notification/getNotifications')
          // To get player coin balance
          this.$store.dispatch('player/totalBalance')
          // Fetch the new updated mission detail
          await this.fetchMissionDetail()
          this.displaySuccessClaimDialog = true
          setTimeout(() => {
            this.displaySuccessClaimDialog = false
          }, 1500)
        }
        this.claimLoading = false
      },
      onDisplayActivityDetail() {
        if (this.claimLoading) return
        this.displayActivityDetailDialog = true
      },
      async fetchMissionDetail() {
        await this.$store.dispatch(
          'activities/mission-reward/getMissionById',
          this.$route.query.mission_id
        )
      }
    }
  }
